import React from "react";
import {moment} from "../../../../../vendor";
import t from "../../../helpers/t";
import hljs from 'highlight.js';
import 'highlight.js/styles/github.css';

function syntaxHighlight(json) {
    //console.log(typeof json);
        json = JSON.stringify(JSON.parse(json), undefined, '\t');

    //console.log(json);
    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    let jnew = json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
        var cls = 'number';
        if (/^"/.test(match)) {
            if (/:$/.test(match)) {
                cls = 'key';
            } else {
                cls = 'string';
            }
        } else if (/true|false/.test(match)) {
            cls = 'boolean';
        } else if (/null/.test(match)) {
            cls = 'null';
        }
        return '<span class="' + cls + '">' + match + '</span>';
    });
   // console.log(jnew);
    return jnew;
}
const _showPopUp = (text,title,type) => {
    //console.log(beautify(text, null, 4));
    if(type === 'json') {
        text = syntaxHighlight(text);//beautify(JSON.parse(text), null, '  ');
    }
    /*let data = JSON.parse(text);
    data = JSON2.stringify(JSON2.decycle(data), null, '  ');*/
    //console.log(text);
  //  console.log(text);
    let output = "<html><head>"+
        '<link href="https://fonts.googleapis.com/css?family=Open+Sans:400,600" rel="stylesheet">'+
        '<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.7.0/styles/default.min.css">'+
        '<script>hljs.highlightAll();</script>'+
        "<title>"+t(title)+"</title>"+
        '<style type="text/css">'+
        'body { font-family: "Open Sans",Helvetica,Arial,sans-serif; background-color: white  } '+
        "hode, html, table, thead { width: 100%; } "+
        "h4 { font-size: 18px; } "+
        ".printSpacer { height:100px; } "+
        ".key { color: red; } " +
        ".string { color: darkblue; } " +
        ".number { color: seagreen; } " +
        ".boolean { color: navy;font-weight: bold; } " +
        ".null { color: navy;font-weight: bold; } " +
        "</style> </head><div><pre>"+text +`</pre></div></body>
            </html>`;
    let rV = -1; // Return value assumes failure.

    if (navigator.appName == 'Microsoft Internet Explorer' || navigator.appName == 'Netscape') {

        var uA = navigator.userAgent;
        var rE = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");

        if (rE.exec(uA) != null) {
            rV = parseFloat(RegExp.$1);
        }
        else if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            rV = 11;
        }
    }

    const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    const newWindow = window.open('', '', 'height=700,width=1374');

    newWindow.document.body.innerHTML = '';
    newWindow.document.body.innerHTML = output;
    if (rV >=10 || isChrome) {
        newWindow.focus(); // necessary for IE >= 10*
    } else {
        // e.g. Firefox
        setTimeout(() => {
            newWindow.opener.focus();
        }, 0);
    }
    return true;
}

const ErrorListItem = (props) => {
    const error = props.error;

    return (
        <>
        <div className={"inb-c-item inb-c-item--error row"}  key={"div_row_"+error.id+"_standard"}>
            <div className="large-1 medium-12 small-12 column  padding-1 show-label" id="error-id" key={"div_error_id_"+error.id} title={t('id')}>
                <span title="ID">
                    {error.id}
                </span>
             </div>
            <div className="large-1 medium-12 small-12 column show-label" id="url" key={"div_error_url_"+error.id}  title={t('url')} >
                <span className="text-nowrap">
                    {error.url}
                </span>
            </div>
            <div className="large-1 medium-12 small-12 column show-label" id="inb-priority" title={t('priority')} key={"div_error_priority_"+error.id}>
                {error.priority}
            </div>
            <div className="large-1 medium-12 small-12 column show-label" id="inb-type" title={t('errortype')} key={"div_error_type_"+error.id}>
                {error.type}
            </div>
            <div className="large-1 medium-12 small-12 column show-label" id="inb-code" title={t('code',null,'capital')} key={"div_error_code_"+error.id}>
                {error.code}
            </div>
            <div className="large-1 medium-12 small-12 column show-label" title={t('message',null,'capital')} style={{minHeight:"40px"}} key={"div_error_message_"+error.id}>
                <span className="text-nowrap">
                    {error.message}
                </span>
            </div>
            <div className="large-1 medium-12 small-12 medium-offset-0 column show-label" title={t('Client ID',null,'capital')} id="inb-client_id" key={"div_error_client_id_"+error.id}>
                <span className="text-nowrap">
                    {error.client_id}
                </span>
            </div>
            <div className="large-1 medium-12 small-12 medium-offset-0 column " id="inb-request" key={"div_error_request_"+error.id} title={t("Request")}>
                <span className="text-nowrap">
                    <a href="#" onClick={() => _showPopUp(error.request, 'request', 'json')}>{t('show_${a}',{a:t('Request')})}</a>
                </span>
            </div>
            <div className="large-1 medium-12 small-12 medium-offset-0 column " id="inb-header" key={"div_error_header_"+error.id} title={t('Header',null,'capital')}>
                <span className="text-nowrap">
                    <a href="#" onClick={() => _showPopUp(error.header, 'header','json')}>{t('show_${a}',{a:t('Header')})}</a>
                </span>
            </div>
            <div className="large-1 medium-12 small-12 medium-offset-0 column " id="inb-response-data" key={"div_error_responseData_"+error.id} title={t('Response Data')}>
                <span className="text-nowrap">
                    <a href="#" onClick={() => _showPopUp(error.responseData, 'response','json')}>{t('show_${a}',{a:t('Response Data')})}</a>
                </span>
            </div>
            <div className="large-1 medium-12 small-12 medium-offset-0 column" id="inb-stack-trace" key={"div_error_stackTrace_"+error.id} title={t('Stack Trace')}>
                <span className="text-nowrap">
                    <a href="#" onClick={() => _showPopUp(error.stackTrace, 'stack','text')}>{t('show_${a}',{a:t('Stack Trace')})}</a>
                </span>
            </div>
            <div className="large-1 medium-12 small-12 medium-offset-0 column show-label" id="inb-created" key={"div_error_created_"+error.id} title={t('created',null,'capital')}>
                <span className="text-nowrap">
                    {moment(error.created).format('DD.MM.YYYY hh:mm')}
                </span>
            </div>

        </div>
            </>
    );
}

export default ErrorListItem;